import { useSearchParams, useNavigate } from 'react-router-dom'
import Header from '../components/Header'

export default function VerifyResult() {
const [params] = useSearchParams()
const navigate = useNavigate()
const status = params.get('status')
const map = {
ok: { icon: '✅', title: 'Email confirmed', body: 'Thanks — you can now accept bookings.' },
already: { icon: '✅', title: 'Already confirmed', body: 'This email address has already been confirmed.' },
expired: { icon: '⏰', title: 'Link expired', body: 'That confirmation link has expired. Go to My Bookings or My Listings and tap "Email me the confirmation link" to get a fresh one.' },
invalid: { icon: '⚠️', title: 'Invalid link', body: "We couldn't find that confirmation link. Check you copied the whole thing from your email." },
error: { icon: '⚠️', title: 'Something went wrong', body: 'Please try the link again, or get in touch at hello@hireitnow.au.' },
}
const s = map[status] || map.error
return (
<div><Header />
<div className="container" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
<div style={{ fontSize: 64, marginBottom: 16 }}>{s.icon}</div>
<h2>{s.title}</h2>
<p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>{s.body}</p>
{status === 'ok' || status === 'already'
? <button className="btn btn-primary" onClick={() => navigate('/my-bookings')}>Go to my bookings</button>
: <button className="btn btn-primary" onClick={() => navigate('/')}>Browse listings</button>}
</div>
</div>
)
}
